import type { PageKey } from "@hawk/shared";

export type LegacyRouteRedirect = {
  from: string;
  to: string;
  pageKey: PageKey;
};

type ConnectedRoute = {
  path: string;
  pageKey: PageKey;
};

export const LEGACY_ROUTE_REDIRECTS: readonly LegacyRouteRedirect[] = [
  {
    from: "/people",
    to: "/directory/people",
    pageKey: "people",
  },
  {
    from: "/badge-requests",
    to: "/badges/requests",
    pageKey: "badgeRequests",
  },
  {
    from: "/contractors",
    to: "/badges/contractor-pool",
    pageKey: "badgeIssuance",
  },
  {
    from: "/badges",
    to: "/badges/permanent",
    pageKey: "badges",
  },
  {
    from: "/badges/active",
    to: "/badges/permanent",
    pageKey: "badges",
  },
  {
    from: "/settings/catalog",
    to: "/access-control/zones",
    pageKey: "settingsCatalog",
  },
  {
    from: "/settings/badge-templates",
    to: "/badges/templates",
    pageKey: "settingsBadgeTemplates",
  },
  {
    from: "/settings/users",
    to: "/directory/users",
    pageKey: "settingsAdministration",
  },
  {
    from: "/settings/administration",
    to: "/administration/roles",
    pageKey: "settingsAdministration",
  },
  {
    from: "/settings/devices",
    to: "/access-control/terminals",
    pageKey: "devices",
  },
  {
    from: "/devices",
    to: "/access-control/terminals",
    pageKey: "devices",
  },
];

const CONNECTED_ROUTES: readonly ConnectedRoute[] = [
  { path: "/dashboard", pageKey: "dashboard" },
  { path: "/visits", pageKey: "visits" },
  { path: "/badges/requests", pageKey: "badgeRequests" },
  { path: "/badges/templates", pageKey: "settingsBadgeTemplates" },
  { path: "/badges/initial-enrollment", pageKey: "badgeInitialEnrollment" },
  { path: "/badges/production/requests", pageKey: "badgeRequests" },
  { path: "/badges/production/direct", pageKey: "badgeInitialEnrollment" },
  { path: "/badges/production/finalize", pageKey: "badgeIssuance" },
  { path: "/badges/production/ready", pageKey: "badgeIssuance" },
  { path: "/badges/print-queue", pageKey: "badgeIssuance" },
  { path: "/badges/visitor-pool", pageKey: "badgeIssuance" },
  { path: "/badges/special-pool", pageKey: "badgeIssuance" },
  { path: "/badges/contractor-pool", pageKey: "badgeIssuance" },
  { path: "/badges/all", pageKey: "badges" },
  { path: "/badges/permanent", pageKey: "badges" },
  { path: "/badges/visitor", pageKey: "badges" },
  { path: "/badges/special", pageKey: "badges" },
  { path: "/badges/contractor", pageKey: "badges" },
  { path: "/directory/people", pageKey: "people" },
  { path: "/directory/users", pageKey: "settingsAdministration" },
  { path: "/access-control/zones", pageKey: "settingsCatalog" },
  { path: "/access-control/profiles", pageKey: "accessProfiles" },
  { path: "/access-control/checkpoints", pageKey: "settingsCatalog" },
  { path: "/access-control/terminals", pageKey: "devices" },
  {
    path: "/administration/organizations",
    pageKey: "settingsOrganizations",
  },
  { path: "/administration/roles", pageKey: "settingsAdministration" },
  { path: "/reports", pageKey: "reports" },
  { path: "/hawk-eye", pageKey: "hawkEye" },
  { path: "/settings", pageKey: "settings" },
];

export function getConnectedRoutePageKey(pathname: string) {
  const legacyRoute = LEGACY_ROUTE_REDIRECTS.find(
    (redirect) => redirect.from === pathname,
  );
  if (legacyRoute) {
    return legacyRoute.pageKey;
  }

  return (
    CONNECTED_ROUTES.find((route) => pathname === route.path)?.pageKey ?? null
  );
}

export function isConnectedRoutePath(pathname: string) {
  return getConnectedRoutePageKey(pathname) !== null;
}
